import Axios from 'axios'
// import http from '@/services/http.service'

const USER_ID_KEY = 'bizoo.userId'
const LOGIN_ID_KEY = 'bizoo.loginId'
const COMPANY_CODE_KEY = 'bizoo.companyCode'
const ACCESS_TOKEN_KEY = 'bizoo.accessToken'
const REFRESH_TOKEN_KEY = 'bizoo.refreshToken'
const REFRESH_URL_KEY = 'bizoo.refreshUrl'
const EXPIRES_AT_KEY = 'bizoo.expiresAt'

const storage = localStorage

const AUTH_API_URL = process.env.VUE_APP_AUTH_API_URL_BASE
const http = Axios.create({
  baseURL: AUTH_API_URL || '',
})

// const URL_BASE = process.env.VUE_APP_API_URL_BASE

/**
 * 認証情報を使ってトークンをリクエストする
 */
export async function requestToken(credentials) {
  // const response = await axios.post(`${URL_BASE}/tokens`, credentials)
  if (!AUTH_API_URL) {
    return {
      // 設定ファイルから取る？
      companyCode: 'dummy',
      userId: 'dummy',
      accessToken:
        'eyJzaXRlIjoiZGV2IiwiY29tcGFuaWVzIjpbImNvbXBhbnkxIiwiY29tcGFueTIiXSwidXNyIjoiYzNkODdiZGMtMjQ2ZC00MThkLTg5YWYtNGI5OWQ1NTdlNmMxIiwicHJ2IjpbImFkbWluIl0sImlzcyI6ImJpem9vcGUiLCJleHAiOjE3MTQ1Nzc4MDIsImlhdCI6MTYxNDU3NTQwMn0',
      refreshToken: 'None',
      refreshUrl: 'None',
    }
  }

  const response = await http.post('/tokens', credentials)
  return response.data
}

/**
 * 保存されているトークンのユーザID取得
 */
export function getUserId() {
  return storage.getItem(USER_ID_KEY)
}

/**
 * 保存されているトークンのログインID取得
 */
export function getLoginId() {
  return storage.getItem(LOGIN_ID_KEY)
}

/**
 * 保存されているトークンのログイン企業コード取得
 */
export function getCompanyCode() {
  return storage.getItem(COMPANY_CODE_KEY)
}

/**
 * 保存されているアクセストークン取得
 *
 * 保存されていない場合null
 */
export function getAccessToken() {
  return storage.getItem(ACCESS_TOKEN_KEY)
}

/**
 * 保存されているアクセストークン取得
 *
 * 保存されていない場合null
 */
export function getRefreshToken() {
  return storage.getItem(REFRESH_TOKEN_KEY)
}

/**
 * リフレッシュURL取得
 */
export function getRefreshUrl() {
  return storage.getItem(REFRESH_URL_KEY)
}

/**
 * 有効期限取得
 */
export function getExpiresAt() {
  const v = storage.getItem(EXPIRES_AT_KEY)

  if (!v) {
    return undefined
  }

  // トークンレスポンスの有効期限はエポック秒なので
  // ミリ秒にしてからDateにします。
  return new Date(parseInt(`${v}000`))
}

/**
 * トークン情報の保存
 */
export function save(
  userId,
  companyCode,
  loginId,
  accessToken,
  refreshToken,
  refreshUrl,
  expiresAt,
) {
  storage.setItem(USER_ID_KEY, userId)
  storage.setItem(COMPANY_CODE_KEY, companyCode)
  storage.setItem(LOGIN_ID_KEY, loginId)
  storage.setItem(ACCESS_TOKEN_KEY, accessToken)
  storage.setItem(REFRESH_TOKEN_KEY, refreshToken)
  storage.setItem(REFRESH_URL_KEY, refreshUrl)
  storage.setItem(EXPIRES_AT_KEY, expiresAt)
}

export function hasTokenSaved() {
  return getAccessToken() && getRefreshToken()
}

/**
 * トークンのリフレッシュ
 */
export async function renewAccessToken() {
  const userId = getUserId()
  const loginId = getLoginId()
  const companyCode = getCompanyCode()
  const refreshToken = getRefreshToken()

  if (!AUTH_API_URL) {
    // 認証URLを設定していないデバッグモードではトークンの
    // 有効期限切れはないので特に何もする必要はない
    return
  }

  let response

  try {
    response = await http.post('/tokens/renew', {
      userId,
      refreshToken,
    })
  } catch (err) {
    if (err.response.status === 400) {
      // トークンリフレッシュ失敗はもうどうしようもない
      remove()
      return
    }
    throw err
  }

  save(
    userId,
    companyCode,
    loginId,
    response.data.accessToken,
    response.data.refreshToken,
    response.data.refreshUrl,
    response.data.expiresAt,
  )
}

/**
 * トークンの破棄
 *
 * リフレッシュトークン諸共全て破棄するので、以降は認証情報を以って
 * アクセストークン再取得が必須です。
 */
export function remove() {
  storage.removeItem(USER_ID_KEY)
  storage.removeItem(COMPANY_CODE_KEY)
  storage.removeItem(LOGIN_ID_KEY)
  storage.removeItem(ACCESS_TOKEN_KEY)
  storage.removeItem(REFRESH_TOKEN_KEY)
  storage.removeItem(REFRESH_URL_KEY)
  storage.removeItem(EXPIRES_AT_KEY)
}
